import { render } from "./DashboardLayouts.vue?vue&type=template&id=0592df88"
import script from "./DashboardLayouts.vue?vue&type=script&lang=js"
export * from "./DashboardLayouts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Vue Project\\inalife-admin-dashboard\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__